import { urlConfig } from "../../config/urlConfig";
import { postCall } from "../httpService";
import { ListFieldModel } from "../../types/ListFieldModel";
import { CompareMetaDataRequestModel, FileDownloadRequestModel, RequestModel } from "../../types/ListSearchModel";

const getField = urlConfig.GetField; // Get the GetField endpoint from urlConfig
const listSearchUrl = urlConfig.ListSearch; // Get the GetField endpoint from urlConfig
const compareMetaDataUrl = urlConfig.CompareMetaData;
const fileDownloadApiUrl = urlConfig.FileDownloadApi;

export const getFieldData = async (params: ListFieldModel) => {
    try {
        const response = await postCall(getField,  params );
        return response.data;
    } catch (error) {
        console.error('Error fetching data', error);
        throw error;
    }
};

export const getListSearchData = async (listSearchModel: RequestModel) => {
    try {
        const response = await postCall(listSearchUrl, listSearchModel);
        return response.data;
    } catch (error) {
        console.error('Error fetching ListSearchData', error);
        throw error;
    }
};

export const getCompareMetaData = async (listSearchModel: CompareMetaDataRequestModel) => {
    try {
        const response = await postCall(compareMetaDataUrl, listSearchModel);
        return response.data;
    } catch (error) {
        console.error('Error fetching CompareMetaData', error);
        throw error;
    }
};

export const getFileDownload = async (fileDownloadModel: FileDownloadRequestModel) => {
    try {
        const response = await postCall(fileDownloadApiUrl, fileDownloadModel);
        return response.data;
    } catch (error) {
        console.error('Error fetching FileDownload', error);
        throw error;
    }
};
